import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import {
  BrandSearch,
  BrandSearchVariables,
  GetTrashCollection,
  GetTrashCollectionVariables,
  GetTrashCollections,
  GetTrashCollectionsVariables,
  GetTrashCollectionBrandLeaderboard,
  GetTrashCollectionBrandLeaderboardVariables,
  GetTrashCollectionStateLeaderboard,
  GetTrashCollectionStateLeaderboardVariables,
} from '@generated/graphql';

export const getTrashCollectionStateLeaderboard: TypedDocumentNode<
  GetTrashCollectionStateLeaderboard,
  GetTrashCollectionStateLeaderboardVariables
> = gql`
  query GetTrashCollectionStateLeaderboard {
    trashCollectionStateLeaderboard {
      stateCode
      stateName
      totalWeightInKgs
    }
  }
`;

export const getTrashCollectionBrandLeaderboard: TypedDocumentNode<
  GetTrashCollectionBrandLeaderboard,
  GetTrashCollectionBrandLeaderboardVariables
> = gql`
  query GetTrashCollectionBrandLeaderboard {
    trashCollectionBrandLeaderboard {
      brandName
      totalWeightInKgs
    }
  }
`;

export const brandSearch: TypedDocumentNode<BrandSearch, BrandSearchVariables> = gql`
  query BrandSearch($query: String!, $first: Int) {
    brandSearch(query: $query) {
      brands(first: $first) {
        edges {
          node {
            externalId
            name
          }
        }
      }
    }
  }
`;

export const getTrashCollection: TypedDocumentNode<
  GetTrashCollection,
  GetTrashCollectionVariables
> = gql`
  query GetTrashCollection($externalId: String!) {
    trashCollection(externalId: $externalId) {
      externalId
      brandName
      createdAt
      description
      stateName
      latitude
      longitude
      weightInKg
      image(width: 800, height: 800, croppingStrategy: SMART) {
        url
        width
        height
      }
      user {
        displayName
        nickname
        avatar(croppingStrategy: CENTER, height: 128, width: 128) {
          url
        }
      }
    }
  }
`;

export const getTrashCollections: TypedDocumentNode<
  GetTrashCollections,
  GetTrashCollectionsVariables
> = gql`
  query GetTrashCollections($first: Int!, $after: String) {
    trashCollections(first: $first, after: $after) {
      edges {
        node {
          createdAt
          description
          externalId
          stateName
          user {
            displayName
            avatar(croppingStrategy: CENTER, height: 128, width: 128) {
              url
            }
          }
          weightInKg
          image(width: 400, height: 400, croppingStrategy: SMART) {
            url
            width
            height
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      totalWeightInKgs
    }
  }
`;
